
import { Loader } from "@googlemaps/js-api-loader";

export default {
	WEATHER_API_KEY: `e25e17701cce464d9b2203416252509`,
	GOOGLE_API_KEY: `AIzaSyAsoksz09zxCILe0AhfoOkQQd0HNAzPYUU`,
	GOOGLE_MAPS_LOADER: null,
	async getGoogleMapsClient() {
		if (this.GOOGLE_MAPS_LOADER) return this.GOOGLE_MAPS_LOADER;

		const loader = new Loader({
			apiKey: this.GOOGLE_API_KEY,
			version: "weekly",
			libraries: ["geocoding", "maps", "places"]
		});

		this.GOOGLE_MAPS_LOADER = await loader.load();

		return this.GOOGLE_MAPS_LOADER;
	}
}
